export enum ChatBotTrackEvents {
  COPILOT_BUBBLE_TAP = 'COPILOT_bubble_tap',
  COPILOT_WELCOME_VIDEO = 'COPILOT_welcome_video',
  COPILOT_TERMS_OK = 'COPILOT_terms_ok',
  COPILOT_CLOSE = 'COPILOT_close',
  COPILOT_CLOSE_CONFIRM = 'COPILOT_close_confirm',
  COPILOT_CLOSE_REJECT = 'COPILOT_close_reject',
  COPILOT_SEND_TEXT = 'COPILOT_send_text',
  COPILOT_SEND_AUDIO = 'COPILOT_send_audio',
  COPILOT_REQUEST_HINT = 'COPILOT_request_hint',
  COPILOT_TAP_HINT = 'COPILOT_tap_hint',
  COPILOT_CHAT_BUBBLE_OPTIONS = 'COPILOT_chat_bubble_options',
  COPILOT_CHAT_THUMB_UP = 'COPILOT_chat_thumb_up',
  COPILOT_CHAT_THUMB_DOWN = 'COPILOT_chat_thumb_down',
  COPILOT_LISTEN = 'COPILOT_listen',
  COPILOT_TRANSLATE = 'COPILOT_translate',
  COPILOT_RECORDING_CANCEL = 'COPILOT_recording_cancel',
  COPILOT_HEADER_SPEAK_WITH_JENNY = 'COPILOT_header_speak_with_jenny',
  COPILOT_BANNER_SPEAK_WITH_JENNY = 'COPILOT_banner_speak_with_jenny',
  COPILOT_ASK_JENNY_MINILESSONS = 'COPILOT_ask_jenny_minilessons',
  AI_FEEDBACK_PRACTICE = 'AI_FEEDBACK_practice'
}

export type ChatBotTrackEventsData = {
  data?: {
    event: ChatBotTrackEvents;
  };
};



// WEBPACK FOOTER //
// ./ts/app/shared/types/chat-bot-track-events.enum.ts